import { Text, Dialog, Button } from '@chakra-ui/react';
import { useState } from 'react';

const ImportantInfoDialog = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(() => {
    const hasSeenDialog = localStorage.getItem('sksis-dialog-shown');
    if (!hasSeenDialog) {
      // Save to localStorage that dialog has been shown
      localStorage.setItem('sksis-dialog-shown', 'true');
      return true;
    }
    return false;
  });

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  return (
    <Dialog.Root open={isDialogOpen} onOpenChange={(details) => setIsDialogOpen(details.open)}>
      <Dialog.Trigger />
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content>
          <Dialog.CloseTrigger />
          <Dialog.Header>
            <Dialog.Title>Important!</Dialog.Title>
          </Dialog.Header>
          <Dialog.Body>
            <Text>
              SKSIS is based on historical soil survey information from CanSIS, <a href="https://sksis.ca/sis.agr.gc.ca/cansis" target='_blank' style={{ textDecoration: 'underline', color: 'blue' }}>the Canadian Soil Information Service</a>. Saskatchewan soil survey maps are at a scale of 1:100,000 and map units correspond to a polygon, not to individual quarter sections of land. Field-scale interpretations are limited at this scale.
            </Text>
          </Dialog.Body>
          <Dialog.Footer>
            <Dialog.ActionTrigger asChild>
              <Button onClick={handleCloseDialog}>Close</Button>
            </Dialog.ActionTrigger>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
};

export default ImportantInfoDialog;
